import React from 'react';
import { Box, Typography } from '@material-ui/core';

/**
 * Placeholder host for future sandboxed iframe components.
 * Does NOT load remote code. Renders fallback children or a controlled notice.
 */
export default function ExternalComponentHost({
  definition,
  nodeId,
  fallback,
}) {
  if (fallback) {
    return fallback;
  }
  return (
    <Box
      p={2}
      m={1}
      style={{
        border: '1px dashed #90a4ae',
        background: '#eceff1',
        borderRadius: 4,
      }}
      data-testid="external-runtime-placeholder"
      data-node-id={nodeId}
      data-component={definition && definition.id}
    >
      <Typography variant="subtitle2">External component unavailable</Typography>
      <Typography variant="body2" color="textSecondary">
        {(definition && definition.displayName) || 'Component'} requires sandbox runtime
        (not implemented). Add a fallback node for production publish.
      </Typography>
    </Box>
  );
}
